import {Component, Input} from '@angular/core';
import {Event} from '../../model/event';
import {Tournament} from '../../model/tournament';
import {PlayerDisplayComponent} from '../player-display/player-display.component';
import {Team} from "../../model/team";

@Component({
  selector: 'app-team-display',
  standalone: true,
  imports: [PlayerDisplayComponent],
  template: `
    <app-player-display
      [player]="team.player1"
      [event]="event"
      [tournament]="tournament"
      [exlicitSubstitute]="explicitSubstitute">
    </app-player-display>

    @if (event.doublesEvent && team.player2) {
      @if (this.inline) {
        /
      } @else {
        <br />
      }
      <app-player-display
        [player]="team.player2"
        [event]="event"
        [tournament]="tournament">
      </app-player-display>
    }
  `
})
export class TeamDisplayComponent {
  @Input({ required: true }) team!: Team;
  @Input({ required: true }) event!: Event;
  @Input({ required: true }) tournament!: Tournament;
  @Input({ required: false }) inline: boolean = true;
  @Input({ required: false }) explicitSubstitute: boolean = false;
}
